import studentRequest from 'utils/studentRequest'

export const ASSESSMENT_TYPES = {
  FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_FAILURE: 'FETCH_QUESTIONS_FAILURE',
  SAVE_QUESTION_RESPONSE: 'SAVE_QUESTION_RESPONSE',
  FETCH_ACTIVE_ASSESSMENTS_REQUEST: 'FETCH_ACTIVE_ASSESSMENTS_REQUEST',
  FETCH_ACTIVE_ASSESSMENTS_SUCCESS: 'FETCH_ACTIVE_ASSESSMENTS_SUCCESS',
  FETCH_ACTIVE_ASSESSMENTS_FAILURE: 'FETCH_ACTIVE_ASSESSMENTS_FAILURE',
  FETCH_COMPLETED_ASSESSMENTS_REQUEST: 'FETCH_COMPLETED_ASSESSMENTS_REQUEST',
  FETCH_COMPLETED_ASSESSMENTS_SUCCESS: 'FETCH_COMPLETED_ASSESSMENTS_SUCCESS',
  FETCH_COMPLETED_ASSESSMENTS_FAILURE: 'FETCH_COMPLETED_ASSESSMENTS_FAILURE',
  SET_ACTIVE_ASSESSMENT_FILTERS: 'SET_ACTIVE_ASSESSMENT_FILTERS',
  SET_COMPLETED_ASSESSMENT_FILTERS: 'SET_COMPLETED_ASSESSMENT_FILTERS',
  SET_CURRENT_ASSESSMENT_ID: 'SET_CURRENT_ASSESSMENT_ID',
  SAVE_ASSESSMENT_RESPONSE: 'SAVE_ASSESSMENT_RESPONSE',
  SAVE_RESPONSE_REQUEST: 'SAVE_RESPONSE_REQUEST',
  SAVE_RESPONSE_SUCCESS: 'SAVE_RESPONSE_SUCCESS',
  SAVE_RESPONSE_FAILURE: 'SAVE_RESPONSE_FAILURE',
  SUBMIT_ASSESSMENT_SUCCESS: 'SUBMIT_ASSESSMENT_SUCCESS',
  SUBMIT_ASSESSMENT_FAILURE: 'SUBMIT_ASSESSMENT_FAILURE',
  FETCH_REPORTS_REQUEST: 'FETCH_REPORTS_REQUEST',
  FETCH_REPORTS_SUCCESS: 'FETCH_REPORTS_SUCCESS',
  FETCH_REPORTS_FAILURE: 'FETCH_REPORTS_FAILURE',
  SET_COMMUNICATION_QUESTIONS: 'SET_COMMUNICATION_QUESTIONS',
  RESET_RESPONSES: 'RESET_RESPONSES',
  SET_CURRENT_ASSESSMENT_INSTRUCTIONS: 'SET_CURRENT_ASSESSMENT_INSTRUCTIONS',
  STORE_VIDEO_RESPONSE: 'STORE_VIDEO_RESPONSE',
  STORE_AUDIO_RESPONSE: 'STORE_AUDIO_RESPONSE',
}

export const fetchQuestionsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_REQUEST,
})

export const fetchQuestionsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_SUCCESS,
  payload: data,
})

export const fetchQuestionsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_FAILURE,
  payload: error,
})

export const fetchActiveAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_REQUEST,
})

export const fetchActiveAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchActiveAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_FAILURE,
  payload: error,
})

export const fetchCompletedAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_REQUEST,
})

export const fetchCompletedAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchCompletedAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_FAILURE,
  payload: error,
})

export const setActiveAssessmentFilters = filters => ({
  type: ASSESSMENT_TYPES.SET_ACTIVE_ASSESSMENT_FILTERS,
  payload: filters,
})

export const setCompletedAssessmentFilters = filters => ({
  type: ASSESSMENT_TYPES.SET_COMPLETED_ASSESSMENT_FILTERS,
  payload: filters,
})

export const resetResponses = () => ({
  type: ASSESSMENT_TYPES.RESET_RESPONSES,
})

export const setCurrentAssessmentId = assessment => ({
  type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_ID,
  payload: {
    assessment_id: assessment.id,
    assessment_set_id: assessment.assessment_set_id,
    assessment_assigned_id: assessment.assessment_assigned_id,
    startTime: assessment.startTime,
    endTime: assessment.endTime,
    type: assessment.type,
    title: assessment.title,
    duration: assessment.duration,
  },
})

export const setCurrentAssessmentInstructions = instructions => ({
  type: ASSESSMENT_TYPES.SET_COMMUNICATION_INSTRUCTIONS,
  payload: instructions,
})

export const fetchReportsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_REQUEST,
})

export const fetchReportsSuccess = reports => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_SUCCESS,
  payload: reports,
})

export const fetchReportsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_FAILURE,
  payload: error,
})

export const fetchAssessmentQuestions = assessmentSetId => async dispatch => {
  dispatch(resetResponses())
  dispatch(fetchQuestionsRequest())
  try {
    const res = await studentRequest.get(
      `students/getAssessmentQuestions?assessment_set_id=${assessmentSetId}`
    )
    console.log('Assessment questions fetched successfully', res)
    if (res.data.message === 'success') {
      dispatch(fetchQuestionsSuccess(res?.data))
      console.log('Assessment questions fetched successfully')
    } else {
      throw new Error('Failed to fetch assessment questions')
    }
  } catch (error) {
    dispatch(fetchQuestionsFailure(error))
    console.error('Error fetching assessment questions:', error)
  }
}

export const fetchCommunicationInstructions = (assessment_set_id) => async dispatch => {
  try {
    console.log('Fetching communication instructions:', assessment_set_id)
    const queryParams = new URLSearchParams({
      assessment_set_id: assessment_set_id || ''
    }).toString()


    const res = await studentRequest.get(
      `students/getCommunicationInstructions?${queryParams}`
    )
    console.log('Communication instructions fetched successfully', res)

    if (res.data.message === 'success') {
      dispatch({
        type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_INSTRUCTIONS,
        payload: res.data.data.instructions,
      })
      console.log('Communication instructions fetched successfully')
    } else {
      throw new Error('Failed to fetch communication instructions')
    }
  } catch (error) {
    console.error('Error fetching communication instructions:', error)
  }
}

export const saveQuestionResponse =
  (questionId, answer, assessment_assigned_id, subQuestionId, questionType) =>
  async dispatch => {
    try {
      dispatch({ type: ASSESSMENT_TYPES.SAVE_RESPONSE_REQUEST })

      const payload = {
        questionId,
        assessment_assigned_id,
        ...(subQuestionId
          ? {
              // Communication assessment format
              answer: {
                subQuestionId,
                selectedOption: answer,
              },
            }
          : {
              // Behavior assessment format
              answer,
            }),
      }

      const res = studentRequest.post('students/assessments/saveResponse', {
        payload,
      })
      console.log('Payload:', payload)

      dispatch({
        type: ASSESSMENT_TYPES.SAVE_RESPONSE_SUCCESS,
        payload: { questionId, answer },
        subQuestionId,
        questionType,
      })

      // console.log('Response saved successfully')
      return res.data
    } catch (error) {
      dispatch({
        type: ASSESSMENT_TYPES.SAVE_RESPONSE_FAILURE,
        payload: error.message,
      })
      console.error('Error saving response:', error)
      throw error
    }
  }

export const fetchActiveAssessments =
  (studentId, filters) => async dispatch => {
    dispatch(fetchActiveAssessmentsRequest())
    // console.log('fetchActiveAssessments', studentId, filters)
    try {
      const queryParams = new URLSearchParams({
        duration: filters?.duration || '',
        assessmentType: filters?.assessmentType || '',
        search: filters?.search || '',
      }).toString()

      const res = await studentRequest.get(
        `students/getActiveAssessments/${studentId}?${queryParams}`
      )

      dispatch(fetchActiveAssessmentsSuccess(res?.data))
      // console.log('Active assessments fetched successfully')
    } catch (error) {
      dispatch(fetchActiveAssessmentsFailure(error))
      // console.log('Error fetching active assessments:', error)
    }
  }

export const fetchCompletedAssessments =
  (studentId, filters) => async dispatch => {
    // console.log('fetchCompletedAssessments', studentId, filters)
    dispatch(fetchCompletedAssessmentsRequest())
    try {
      const queryParams = new URLSearchParams({
        timeFilter: filters?.timeFilter || '',
        assessmentType: filters?.assessmentType || '',
        search: filters?.search || '',
      }).toString()

      const res = await studentRequest.get(
        `students/getCompletedAssessment/${studentId}?${queryParams}`
      )
      dispatch(fetchCompletedAssessmentsSuccess(res?.data))
      // console.log('Completed assessments fetched successfully', res)
    } catch (error) {
      dispatch(fetchCompletedAssessmentsFailure(error))
      // console.log('Error fetching completed assessments:', error)
    }
  }

export const saveAssessmentResponse = (questionId, answer) => ({
  type: ASSESSMENT_TYPES.SAVE_ASSESSMENT_RESPONSE,
  payload: {
    questionId,
    answer,
  },
})

export const submitAssessment = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState()
      const fullName = state?.studentData?.studentDetails?.fullName
      const currentAssessment = state.assessment.currentAssessment

      if (!currentAssessment || !currentAssessment.assessment_assigned_id) {
        throw new Error('No active assessment found')
      }

      const payload = {
        assessment_assigned_id: currentAssessment.assessment_assigned_id,
        response: currentAssessment.responses || {},
        full_name: fullName,
      }
      console.log('Submitting assessment:', payload)

      const response = await studentRequest.post(
        '/students/submitAssessment',
        payload
      )
      console.log('Assessment submitted successfully:', response.data)
      // dispatch({
      //   type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS,
      //   payload: response.data,
      // })

      // After successful submission, fetch the updated completed assessments list
      dispatch(fetchCompletedAssessments())
      dispatch(resetResponses())

      return response.data
    } catch (error) {
      dispatch({
        type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_FAILURE,
        payload: error.message,
      })
      throw error
    }
  }
}

export const uploadVideoResponse =
  (videoBlob, questionId) => async (dispatch,getState) => {
    try {
      // Create form data
      console.log('Video Blob', videoBlob)
      const state = getState()
      const formData = new FormData()
      const studentDetails = state?.studentData?.studentDetails
  
      const baseFilename = `Video_respose_${studentDetails.firstName}${studentDetails.lastName ? `_${studentDetails.lastName}` : ''}-${Date.now()}`
      formData.append('video', videoBlob, `${baseFilename}`)
      console.log('Form data', formData)
      // Upload to Oracle Object Storage
      // const response = await fetch('/students/assessments/uploadVideo', {
      //   method: 'POST',
      //   body: formData,
      // });

      const res = await studentRequest.post(
        'students/assessments/uploadVideo',
        formData, // Send the FormData object directly
        {
          headers: {
            'Content-Type': 'multipart/form-data', // Explicitly set the Content-Type header
          },
        }
      )
      console.log('Upload response:', res.data)
      const { parUrl } = await res.data.data

      // Dispatch action to store PAR URL
      dispatch({
        type: 'STORE_VIDEO_RESPONSE',
        payload: {
          questionId,
          parUrl,
        },
      })

      return parUrl
    } catch (error) {
      console.error('Error uploading video:', error)
      throw error
    }
  }

export const uploadAudioResponse = audioBlob => async (dispatch,getState) => {
  try {
    console.log('Audio Blob', audioBlob)
    const state = getState()
    const formData = new FormData()
    const studentDetails = state?.studentData?.studentDetails

    const baseFilename = `Paragraph_reading_${studentDetails.firstName}${studentDetails.lastName ? `_${studentDetails.lastName}` : ''}-${Date.now()}`
    formData.append('audio', audioBlob, `${baseFilename}`)

    const res = await studentRequest.post(
      'students/assessments/uploadAudio',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    console.log('Upload response:', res.data)
    const { parUrl } = res.data.data
    console.log('Upload PAR:', parUrl)

    // Store just the audio URL
    dispatch({
      type: ASSESSMENT_TYPES.STORE_AUDIO_RESPONSE,
      payload: {
        parUrl,
      },
    })

    return parUrl
  } catch (error) {
    console.error('Error uploading audio:', error)
    throw error
  }
}

export const fetchReports = () => {
  return async (dispatch, getState) => {
    dispatch(fetchReportsRequest())
    try {
      const state = getState()
      const completedAssessments =
        state.assessment.completedAssessments.data || []
      const assessmentIds = completedAssessments.map(
        assessment => assessment.assessment_assigned_id
      )

      // console.log('Fetching reports for assessments:', assessmentIds)

      const response = await studentRequest.post(
        'students/getAssessmentReport',
        {
          assessment_assigned_ids: assessmentIds,
        }
      )
      // console.log('Reports fetched successfully:', response)

      dispatch(fetchReportsSuccess(response.data.data))
    } catch (error) {
      dispatch(fetchReportsFailure(error.message))
    }
  }
}

export const generatePDFReport =
  assessment_assigned_id => async (dispatch, getState) => {
    // console.log('Generating behavior PDF report:')
    try {
      const state = getState()
      const student_id = state?.studentData?.studentDetails?.id

      // Create query parameters
      const queryParams = new URLSearchParams({
        assessment_assigned_id: assessment_assigned_id,
        student_id: student_id,
      }).toString()

      // Make API request and get PDF blob
      const response = await studentRequest.get(
        `/students/assessments/generatePDFReport?${queryParams}`,
        {
          responseType: 'blob', // Important for receiving binary data
          headers: {
            Accept: 'application/pdf',
          },
        }
      )

      // Create blob URL and open in new window
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
      // Clean up blob URL after opening
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error generating behavior PDF report:', error)
      throw error
    }
  }
